import React from 'react';
import PropTypes from 'prop-types';

import { Provider } from './ThemeContext';

export class ThemeProvider extends React.Component {

    static propTypes = {
        children: PropTypes.node,
        initialStyle: PropTypes.string,
        initialColor: 
        PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = {
            style: 'light',
            color: 'primary',
            overrideStyle: false
        };
        //Add Event listener
        this.onChangeTheme = this.onChangeTheme.bind(this)
    }

    static getDerivedStateFromProps(props, state) {
        // Any time the current user changes,
        // Reset any parts of state that are tied to that user.
        // In this simple example, that's just the email.
        if (state.overrideStyle) {
          return {
            
          };
        }
        return null;
    }

    componentDidMount() {
        const { initialStyle, initialColor } = this.props;

        if (!this.state.overrideStyle && initialStyle) {
            this.setState({ style: initialStyle });
        }
        if (!this.state.overrideStyle && initialColor) {
            this.setState({ color: initialColor });
        }
    }

    onChangeTheme(themeState) {
        this.setState(themeState);
        this.state.overrideStyle = themeState.overrideStyle;
    }

    render() {
        const { children } = this.props;
        
        return (
            <Provider
                value={{
                    ...this.state,
                    onChangeTheme: this.onChangeTheme
                }}
            >
                { children }
            </Provider>
        );
    }
}